/**
 * @author sheva2103
 * @project EasyMessager
 * @license MIT
 * @link https://github.com/sheva2103/EasyMessager
 * @email 2103sheva@gmail.com
 * @copyright (c) 2025 Aleksandr (GitHub: sheva2103)
 */
import Worker from 'web-worker';
let worker = null;
const listeners = new Map();
function ensureWorker() {
    if (!worker) {
        worker = new Worker(new URL('./messagesWorker.ts', import.meta.url));
        worker.addEventListener('message', (e) => {
            const { taskId } = e.data;
            const set = listeners.get(taskId);
            if (!set)
                return;
            for (const cb of set)
                cb(e.data);
        });
    }
    return worker;
}
export function postTask(taskId, payload) {
    const w = ensureWorker();
    w.postMessage(Object.assign({ taskId }, payload));
}
export function subscribe(taskId, handler) {
    ensureWorker();
    let set = listeners.get(taskId);
    if (!set) {
        set = new Set();
        listeners.set(taskId, set);
    }
    set.add(handler);
    return () => {
        set.delete(handler);
        if (set.size === 0) {
            listeners.delete(taskId);
        }
    };
}
